export default {"src":"/_next/static/media/blue-tiktok.49baa22a.svg","height":24,"width":24};